module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.articleList.length > 0) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-title"
  }, [_vm._v("PR Newswire")]), _c('ul', {
    staticClass: "list-reset content-list"
  }, _vm._l((_vm.articleList), function(item, idx) {
    return _c('li', {
      key: item.isoDate,
      staticClass: "list-item"
    }, [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd79342e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RssNews.vue
// module id = 1004
// module chunks = 1